var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEmptyData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 102,
    viewBox: "0 0 124 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 45.8848C0 44.7802 0.895431 43.8848 2 43.8848H85.6156C88.3771 43.8848 90.6156 46.1233 90.6156 48.8848V63.2075H2C0.89543 63.2075 0 62.3121 0 61.2075V45.8848ZM11.9233 84.562C11.9233 83.4574 12.8188 82.562 13.9233 82.562H35.7695V63.239H122.001C123.105 63.239 124.001 64.1344 124.001 65.239V85.3924C124.001 86.497 123.105 87.3924 122.001 87.3924H100.154V96.8847C100.154 99.6461 97.9158 101.885 95.1543 101.885H13.9233C12.8188 101.885 11.9233 100.989 11.9233 99.8847V84.562Z",
    fill: "#FDF3F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1104 38.0698H90.8604V40.8061H32.1104V38.0698Z",
    fill: "url(#paint0_linear_1317_71648)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5695 28.188C90.3964 29.0149 90.8605 30.1356 90.8605 31.3032V35.5934H90.8604V45.875H32.1104V37.0625C32.1104 35.8934 32.5745 34.7727 33.3999 33.9473C34.2268 33.1204 35.3475 32.6562 36.5166 32.6562H62.7851C63.0858 31.7661 63.4163 30.7875 63.718 29.8932C64.3231 28.1028 66.0019 26.897 67.8922 26.897H86.4543C87.6219 26.897 88.7426 27.3626 89.5695 28.188Z",
    fill: "url(#paint1_linear_1317_71648)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5147 46.7812C94.7791 45.0863 94.2885 43.359 93.1723 42.0548C92.056 40.7505 90.4257 40 88.7087 40C75.7529 40 47.832 40 34.8761 40C33.1591 40 31.5288 40.7505 30.4126 42.0548C29.2963 43.359 28.8058 45.0863 29.0701 46.7812C30.5653 56.3457 33.2561 73.5683 34.578 82.0312C35.0259 84.8923 37.489 87 40.3839 87H83.2009C86.0958 87 88.5589 84.8923 89.0069 82.0312C90.3288 73.5683 93.0195 56.3457 94.5147 46.7812Z",
    fill: "url(#paint2_linear_1317_71648)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0701 46.7812L29.8236 51.5987C29.5578 49.9023 30.1409 48.1751 31.2571 46.8708C32.3734 45.5666 34.0037 44.816 35.7206 44.816H87.8642C89.5812 44.816 91.2115 45.5666 92.3277 46.8708C93.444 48.1751 94.0271 49.9023 93.7612 51.5987L94.5147 46.7812C94.7791 45.0863 94.2885 43.359 93.1723 42.0548C92.056 40.7505 90.4257 40 88.7087 40C75.7529 40 47.832 40 34.8761 40C33.1591 40 31.5288 40.7505 30.4126 42.0548C29.2963 43.359 28.8058 45.0863 29.0701 46.7812Z",
    fill: "#E9F3FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4365 75.0254C58.4365 73.4039 57.122 72.0879 55.499 72.0879C52.2399 72.0879 47.0096 72.0879 43.749 72.0879C42.1275 72.0879 40.8115 73.4039 40.8115 75.0254V77.9629C40.8115 79.5859 42.1275 80.9004 43.749 80.9004H55.499C57.122 80.9004 58.4365 79.5859 58.4365 77.9629C58.4365 77.0185 58.4365 75.9713 58.4365 75.0254Z",
    fill: "url(#paint3_linear_1317_71648)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.392 34.432C49.3274 34.0178 49.2965 33.6095 49.298 33.2071C49.3009 32.3978 48.6459 31.7368 47.8351 31.7324C47.0244 31.7295 46.3634 32.3846 46.3605 33.1953C46.3576 33.7505 46.4002 34.316 46.4912 34.8888C46.6161 35.6892 47.3695 36.2371 48.17 36.1108C48.9705 35.9859 49.5183 35.2325 49.392 34.432Z",
    fill: "url(#paint4_linear_1317_71648)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9339 28.8025C51.2217 28.4646 51.5449 28.1474 51.9032 27.8507C52.5275 27.3337 52.6156 26.4084 52.0986 25.7827C51.5816 25.1585 50.6563 25.0704 50.0306 25.5874C49.5385 25.9942 49.0935 26.4334 48.697 26.8975C48.1711 27.5158 48.246 28.4426 48.8629 28.9684C49.4798 29.4942 50.408 29.4193 50.9339 28.8025Z",
    fill: "url(#paint5_linear_1317_71648)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4698 25.7313C57.0632 25.5976 57.6889 25.4978 58.3454 25.4317C59.1518 25.3509 59.7408 24.6312 59.66 23.8249C59.5792 23.0185 58.8595 22.4281 58.0532 22.5089C57.2747 22.5867 56.5315 22.7071 55.8265 22.8658C55.0349 23.0435 54.537 23.8293 54.7147 24.6195C54.8924 25.4111 55.6782 25.909 56.4698 25.7313Z",
    fill: "url(#paint6_linear_1317_71648)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9887 25.4257C64.8846 25.4492 65.735 25.4418 66.5458 25.408C67.355 25.3742 67.9851 24.6883 67.9513 23.8791C67.9176 23.0698 67.2331 22.4397 66.4224 22.4735C65.6748 22.5043 64.889 22.5102 64.0636 22.4896C63.2528 22.4691 62.5787 23.1109 62.5581 23.9202C62.5375 24.7309 63.1794 25.4051 63.9887 25.4257Z",
    fill: "url(#paint7_linear_1317_71648)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6148 24.4871C73.5621 24.2125 74.4169 23.8849 75.1836 23.5178C75.9136 23.1667 76.222 22.2884 75.871 21.557C75.5199 20.827 74.6416 20.5186 73.9117 20.8696C73.2801 21.1722 72.5766 21.4395 71.7952 21.6671C71.0168 21.8933 70.5688 22.7085 70.795 23.4869C71.0212 24.2653 71.8363 24.7133 72.6148 24.4871Z",
    fill: "url(#paint8_linear_1317_71648)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.597 19.9105C80.299 18.9088 80.7573 17.841 81.0099 16.7615C81.195 15.9713 80.7029 15.1811 79.9142 14.996C79.1255 14.8124 78.3338 15.303 78.1502 16.0917C77.9784 16.8232 77.667 17.5458 77.1911 18.2243C76.727 18.8882 76.8871 19.8047 77.551 20.2703C78.2149 20.7359 79.1328 20.5743 79.597 19.9105Z",
    fill: "url(#paint9_linear_1317_71648)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4675 10.8688C79.8168 9.35161 78.7975 8.0738 77.5873 7.23955C76.919 6.77836 76.004 6.94726 75.5442 7.61408C75.083 8.28089 75.252 9.19739 75.9188 9.65711C76.7045 10.1991 77.3464 11.0436 77.7679 12.0277C78.0881 12.7738 78.9532 13.119 79.6979 12.7988C80.4425 12.4786 80.7877 11.615 80.4675 10.8688Z",
    fill: "url(#paint10_linear_1317_71648)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6328 6.53298C63.222 -2.46605 76.9945 -1.88442 68.9766 6.53298H61.6328Z",
    fill: "url(#paint11_linear_1317_71648)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6328 8.8125C63.222 17.8101 76.9945 17.2299 68.9766 8.8125H61.6328Z",
    fill: "url(#paint12_linear_1317_71648)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5 9.15625H71.3348C72.1455 9.15625 72.8035 8.49825 72.8035 7.6875C72.8035 6.87675 72.1455 6.21875 71.3348 6.21875H61.5C60.6907 6.21875 60.0312 6.87675 60.0312 7.6875C60.0312 8.49825 60.6907 9.15625 61.5 9.15625Z",
    fill: "url(#paint13_linear_1317_71648)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5 9.15625H71.3348C72.1455 9.15625 72.8035 8.49825 72.8035 7.6875C72.8035 6.87675 72.1455 6.21875 71.3348 6.21875H61.5C60.6907 6.21875 60.0312 6.87675 60.0312 7.6875C60.0312 8.49825 60.6907 9.15625 61.5 9.15625Z",
    fill: "url(#paint14_linear_1317_71648)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.9997,
    cy: 80.9997,
    r: 11.6667,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9997 69.333C77.5713 69.333 72.333 74.5713 72.333 80.9997C72.333 87.428 77.5713 92.6663 83.9997 92.6663C90.428 92.6663 95.6663 87.428 95.6663 80.9997C95.6663 74.5713 90.428 69.333 83.9997 69.333ZM87.9197 83.683C88.258 84.0213 88.258 84.5813 87.9197 84.9197C87.7447 85.0947 87.523 85.1763 87.3013 85.1763C87.0797 85.1763 86.858 85.0947 86.683 84.9197L83.9997 82.2363L81.3163 84.9197C81.1413 85.0947 80.9197 85.1763 80.698 85.1763C80.4763 85.1763 80.2547 85.0947 80.0797 84.9197C79.7413 84.5813 79.7413 84.0213 80.0797 83.683L82.763 80.9997L80.0797 78.3163C79.7413 77.978 79.7413 77.418 80.0797 77.0797C80.418 76.7413 80.978 76.7413 81.3163 77.0797L83.9997 79.763L86.683 77.0797C87.0213 76.7413 87.5813 76.7413 87.9197 77.0797C88.258 77.418 88.258 77.978 87.9197 78.3163L85.2363 80.9997L87.9197 83.683Z",
    fill: "#E11D34"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1317_71648",
    x1: 32.1104,
    y1: 39.4372,
    x2: 90.8604,
    y2: 39.4372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1317_71648",
    x1: 60.2716,
    y1: 26.897,
    x2: 60.2716,
    y2: 45.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B7D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB3BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1317_71648",
    x1: 59.0823,
    y1: 40,
    x2: 59.0823,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDBE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1317_71648",
    x1: 51.0078,
    y1: 80.9004,
    x2: 50.8022,
    y2: 72.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1317_71648",
    x1: 48.1247,
    y1: 36.1289,
    x2: 47.8301,
    y2: 31.7514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1317_71648",
    x1: 50.7121,
    y1: 29.3187,
    x2: 50.5235,
    y2: 25.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1317_71648",
    x1: 57.5647,
    y1: 25.7673,
    x2: 57.465,
    y2: 22.5039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1317_71648",
    x1: 65.6787,
    y1: 25.4393,
    x2: 65.6026,
    y2: 22.4736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1317_71648",
    x1: 73.7907,
    y1: 24.5458,
    x2: 73.6617,
    y2: 20.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1317_71648",
    x1: 79.311,
    y1: 20.5363,
    x2: 78.96,
    y2: 14.9786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1317_71648",
    x1: 78.352,
    y1: 12.9183,
    x2: 78.0423,
    y2: 6.99454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1317_71648",
    x1: 66.1433,
    y1: 0,
    x2: 66.1433,
    y2: 6.53298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDBE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1317_71648",
    x1: 66.1433,
    y1: 8.8125,
    x2: 66.1433,
    y2: 15.3449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDBE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1317_71648",
    x1: 60.0327,
    y1: 7.6875,
    x2: 72.8035,
    y2: 7.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1317_71648",
    x1: 67.4202,
    y1: 9.15625,
    x2: 67.3886,
    y2: 6.21852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004B91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyData);
export default __webpack_public_path__ + "static/media/ic_empty_data.1e181af72dd8e24257d15e6f2be84358.svg";
export { ForwardRef as ReactComponent };